const { ServiceRequestStatus } = require('./reservation');

const WorkOrderStatus = {
  Pending: ServiceRequestStatus.PENDING,
  Completed: ServiceRequestStatus.COMPLETED,
  Deleted: ServiceRequestStatus.CANCELLED,
  _Values: () =>
    Object.keys(WorkOrderStatus)
      .filter(key => typeof WorkOrderStatus[key] !== 'function')
      .map(key => WorkOrderStatus[key]),
};

module.exports = { WorkOrderStatus };
